export const TypesSolServDesova = {
    SET_PROPERTY: "solServDesova/SET_PROPERTY",
    SET_DESOVA_PROPERTY: "solServDesova/SET_DESOVA_PROPERTY",
    SET_MERCADORIA_PROPERTY: "solServDesova/SET_MERCADORIA_PROPERTY",
    SET_MERCADORIA_READONLY: "solServDesova/SET_MERCADORIA_READONLY",
    SET_FINALIZAR_DESOVA: "solServDesova/SET_FINALIZAR_DESOVA",
    SET_COMBOS_AVARIAS: "solServDesova/SET_COMBOS_AVARIAS",
    SET_AVARIAS: "solServDesova/SET_AVARIAS",
    AVARIA_LOCAL_CHECKED: "solServDesova/AVARIA_LOCAL_CHECKED",
    AVARIA_TIPO_CHECKED: "solServDesova/AVARIA_TIPO_CHECKED",
    AVARIA_COMPLEMENTO_CHECKED: "solServDesova/AVARIA_COMPLEMENTO_CHECKED",
    AVARIA_PROVIDENCIA_CHECKED: "solServDesova/AVARIA_PROVIDENCIA_CHECKED",
    AVARIA_PESO: "solServDesova/AVARIA_PESO",
    AVARIA_REMOVER_CHECKED: "solServDesova/AVARIA_REMOVER_CHECKED",
    REMOVE_AVARIAS: "solServDesova/REMOVE_AVARIAS",
    RESET_AVARIAS: "solServDesova/RESET_AVARIAS",
    RESET_REDUCER: "solServDesova/RESET_REDUCER",
    RESET_FINALIZAR_DESOVA: "solServDesova/RESET_FINALIZAR_DESOVA"
}

export const INITIAL = {
    title: undefined,
    titleDescription: undefined,
    solServId: undefined,
    descricaoSolServ: undefined,
    referenciaSolServ: undefined,
    passagemContainerId: undefined,
    lacreMarimex: 'SL',
    motivoInterrupcao: undefined,
    descricaoNF: undefined,
    solServNodes: [],
    containerNodes: [],
    iniciarDesovaNodes: [],
    documentoNodes: [],
    codigoProduto: undefined,
    idNFDadosProduto: undefined,
    volumeNaoReconhecido: '',
    desova: {
        etiqueta: '',
        volume: '',
        preparaEtiqueta: false,
        localidadePaiId: 0,
        localidadeObjeto: {},
        labelLocal: '',
        localidade: 0,
        descricaoLocalidade: '',
        tipo: 0,
        contraMarca: '',
        tipoOperacao: undefined,
        quantidadeRegular: undefined,
        embalagemRegular: -1,
        descricaoEmbalagemRegular: '',
        embalagem: -1,
        descricaoEmbalagem: '',
        empilhadeira: -1,
        altura: undefined,
        largura: undefined,
        comprimento: undefined,
        peso: undefined,
        embalagens: [],
        localidades: [],
        empilhadeiras: []
    },
    mercadoria: {
        MerQtde: undefined,
        MerFabricacao: "",
        MerAdmissao: "",
        MerReferencia: "",
        MerVencimento: ""
    },
    mercadoriaReadOnly: {},
    finalizarDesova: {
        condicaoContainer: 1,
        tipoOperacao: undefined,
        lacreMarimex: '',
        vistoriaFina: -1,
        ajudantes: [],
        listaAjudantes: [],
        divergencias: '',
        observacao: ''
    },
    TiposAvaria: [],
    LocaisAvaria: [],
    ComplementosAvaria: [],
    ProvidenciasAvaria: [],
    Avarias: [],
    avariaLocalChecked: [],
    avariaTipoChecked: [],
    avariaComplementoChecked: [],
    avariaProvidenciaChecked: [],
    avariaRemoverChecked: [],
    avariaPeso: undefined
}

export default function solServDesovaReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesSolServDesova.SET_PROPERTY:

            let stateNew = {};

            Object.assign(stateNew, state);

            stateNew[action.payload.campo] = action.payload.valor;

            return stateNew;
        case TypesSolServDesova.SET_DESOVA_PROPERTY:

            let desovaNew = {};

            Object.assign(desovaNew, state.desova);

            desovaNew[action.payload.campo] = action.payload.valor;

            return {
                ...state,
                desova: desovaNew
            }
        case TypesSolServDesova.SET_MERCADORIA_PROPERTY:

            let mercadoriaNew = {};

            Object.assign(mercadoriaNew, state.mercadoria);

            mercadoriaNew[action.payload.campo] = action.payload.valor;

            return {
                ...state,
                mercadoria: mercadoriaNew
            }
        case TypesSolServDesova.SET_MERCADORIA_READONLY:
            return {
                ...state,
                mercadoriaReadOnly: action.payload.mercadoriaReadOnly
            }
        case TypesSolServDesova.SET_COMBOS_AVARIAS:
            return {
                ...state,
                TiposAvaria: action.payload.Tipos,
                LocaisAvaria: action.payload.Locais,
                ComplementosAvaria: action.payload.Complementos,
                ProvidenciasAvaria: action.payload.Providencias
            };
        case TypesSolServDesova.SET_AVARIAS:
            return {
                ...state,
                Avarias: action.payload
            };
        case TypesSolServDesova.SET_FINALIZAR_DESOVA:
            let finalizarDesovaNew = {};

            Object.assign(finalizarDesovaNew, state.finalizarDesova);

            finalizarDesovaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                finalizarDesova: finalizarDesovaNew
            }
        case TypesSolServDesova.AVARIA_LOCAL_CHECKED:
            return {
                ...state,
                avariaLocalChecked: action.payload
            };
        case TypesSolServDesova.AVARIA_TIPO_CHECKED:
            return {
                ...state,
                avariaTipoChecked: action.payload
            };
        case TypesSolServDesova.AVARIA_COMPLEMENTO_CHECKED:
            return {
                ...state,
                avariaComplementoChecked: action.payload
            };
        case TypesSolServDesova.AVARIA_PROVIDENCIA_CHECKED:
            return {
                ...state,
                avariaProvidenciaChecked: action.payload
            }
        case TypesSolServDesova.AVARIA_PESO:
            return {
                ...state,
                avariaPeso: action.payload
            }
        case TypesSolServDesova.AVARIA_REMOVER_CHECKED:
            return {
                ...state,
                avariaRemoverChecked: action.payload
            };
        case TypesSolServDesova.REMOVE_AVARIAS:
            return ({
                ...state,
                Avarias: [...state.Avarias.filter(function (a, index) { return !state.avariaRemoverChecked.includes(index) })]
            })
        case TypesSolServDesova.RESET_AVARIAS:
            return ({
                ...state,
                TiposAvaria: INITIAL.TiposAvaria,
                LocaisAvaria: INITIAL.LocaisAvaria,
                ComplementosAvaria: INITIAL.ComplementosAvaria,
                ProvidenciasAvaria: INITIAL.ProvidenciasAvaria,
                Avarias: INITIAL.Avarias,
                avariaLocalChecked: INITIAL.avariaLocalChecked,
                avariaTipoChecked: INITIAL.avariaTipoChecked,
                avariaComplementoChecked: INITIAL.avariaComplementoChecked,
                avariaProvidenciaChecked: INITIAL.avariaProvidenciaChecked,
                avariaRemoverChecked: INITIAL.avariaRemoverChecked,
                avariaPeso: INITIAL.avariaPeso
            })
        case TypesSolServDesova.RESET_FINALIZAR_DESOVA:
            return {
                ...state,
                finalizarDesova: INITIAL.finalizarDesova
            }
        case TypesSolServDesova.RESET_REDUCER:
            return INITIAL;
        default:
            return state;
    }
}

export const SolServDesovaActions = {
    setProperty,
    setDesovaProperty,
    setMercadoriaProperty,
    setMercadoriaReadOnly,
    setFinalizarDesova,
    setCombosAvarias,
    setAvarias,
    avariaLocalChecked,
    avariaTipoChecked,
    avariaComplementoChecked,
    avariaProvidenciaChecked,
    avariaPeso,
    avariaRemoverChecked,
    deletarAvarias,
    resetAvarias,
    resetReducer,
    resetFinalizarDesova
}

function setProperty(valor, campo) {
    return {
        type: TypesSolServDesova.SET_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function setDesovaProperty(valor, campo) {
    return {
        type: TypesSolServDesova.SET_DESOVA_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function setMercadoriaProperty(valor, campo) {
    return {
        type: TypesSolServDesova.SET_MERCADORIA_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function setMercadoriaReadOnly(mercadoriaReadOnly) {
    return {
        type: TypesSolServDesova.SET_MERCADORIA_READONLY,
        payload: mercadoriaReadOnly
    }
}

function setFinalizarDesova(valor, campo) {
    return {
        type: TypesSolServDesova.SET_FINALIZAR_DESOVA,
        payload: { valor: valor, campo: campo }
    }
}

function setCombosAvarias(dadosAvarias) {
    return {
        type: TypesSolServDesova.SET_COMBOS_AVARIAS,
        payload: dadosAvarias
    }
}

function setAvarias(dadosAvarias) {
    return {
        type: TypesSolServDesova.SET_AVARIAS,
        payload: dadosAvarias
    }
}

function avariaLocalChecked(checked) {
    return {
        type: TypesSolServDesova.AVARIA_LOCAL_CHECKED,
        payload: checked
    }
}

function avariaTipoChecked(checked) {
    return {
        type: TypesSolServDesova.AVARIA_TIPO_CHECKED,
        payload: checked
    }
}

function avariaComplementoChecked(checked) {
    return {
        type: TypesSolServDesova.AVARIA_COMPLEMENTO_CHECKED,
        payload: checked
    }
}

function avariaProvidenciaChecked(checked) {
    return {
        type: TypesSolServDesova.AVARIA_PROVIDENCIA_CHECKED,
        payload: checked
    }
}

function avariaPeso(peso) {
    return {
        type: TypesSolServDesova.AVARIA_PESO,
        payload: peso
    }
}

function avariaRemoverChecked(checked) {
    return {
        type: TypesSolServDesova.AVARIA_REMOVER_CHECKED,
        payload: checked
    }
}

function deletarAvarias() {
    return {
        type: TypesSolServDesova.REMOVE_AVARIAS
    }
}

function resetAvarias() {
    return {
        type: TypesSolServDesova.RESET_AVARIAS
    }
}

function resetReducer() {
    return {
        type: TypesSolServDesova.RESET_REDUCER
    }
}

function resetFinalizarDesova() {
    return {
        type: TypesSolServDesova.RESET_FINALIZAR_DESOVA
    }
}